import { CartModel, TicketModel } from "../models/cart.model";

export function GetAccountIdFromCart(shoppingCart: CartModel) {
    if (shoppingCart.tickets !== null && shoppingCart.tickets.length > 0) {
        return shoppingCart.tickets[0].event.accountId;
    } else if (shoppingCart.tickets !== null && shoppingCart.giftCertificates.length > 0) {
        return shoppingCart.giftCertificates[0].accountId;
    } else {
        return 0;
    }
}

export function GetEventTotalAmount(cart: CartModel, eventId: number) {
    let amount = 0;

    $.each(cart.tickets, function (i, bt) {
        if (bt.eventId === eventId) {
            amount += bt.totalPricePerTicketName;
            amount -= bt.appliedGCOnUnitPrice;

            if (bt.totalDeductions) {
                amount -= bt.totalDeductions;
            }
        }
    });

    $.each(cart.donations, function (i, bd) {
        if (bd.EventId === eventId) {
            amount += bd.Amount;
        }
    });

    $.each(cart.boxOfficeFees, function (i, bof) {
        if (bof.EventId === eventId) {
            amount += bof.Amount;
        }
    });

    return amount;
}

export function GetFirstEvent(shoppingCart: CartModel) {
    if (shoppingCart && shoppingCart.tickets && shoppingCart.tickets.length > 0) {
        return shoppingCart.tickets[0].eventId;
    } else {
        return 0;
    }
}

export function GetLastEvent(shoppingCart: CartModel) {
    var highestEventId = 0;
    $.each(shoppingCart.tickets, function (i, ticket) {
        if (ticket.event.id > highestEventId) {
            highestEventId = ticket.event.id;
        }
    });
    return highestEventId;
}

export function GetCartLinks(bookingSitePath: string, eventSitePath: string, accountId: number, eventId: number, widgetType: string, widgetEventId: number, isEventListingWidget: boolean, activeQueryStrings: any) {
    var _buyMoreLink, _buyGcLink, _findOtherEventsLink;
    var _findOtherEventsQs = new URLSearchParams();

    if (eventId > 0) {
        var _buyMoreQs = new URLSearchParams();
        _buyMoreQs.append('eid', eventId.toString());

        if (activeQueryStrings.embed) {
            _buyMoreQs.append('embed', activeQueryStrings.embed);
        }

        if (activeQueryStrings.widget) {
            _buyMoreQs.append('widget', activeQueryStrings.widget);
            _findOtherEventsQs.append('eid', widgetEventId.toString());

            if (widgetEventId && widgetEventId > 0 && widgetType) {
                _buyMoreQs.append('type', widgetType);
                _findOtherEventsQs.append('type', widgetType);
            }
        }

        if (isEventListingWidget && accountId > 0) {
            _buyMoreQs.append('wp', 'true');
            _buyMoreQs.append('isEventListingWidget', 'True');
            _buyMoreQs.append('aid', accountId.toString());
        }

        if (activeQueryStrings.qs) {
            _buyMoreQs.append('qs', activeQueryStrings.qs);
        }

        if (activeQueryStrings.source) {
            _buyMoreQs.append('source', activeQueryStrings.source);
        }

        if (activeQueryStrings.cid) {
            _buyMoreQs.append('cid', activeQueryStrings.cid);
        }

        if (activeQueryStrings.tic) {
            _buyMoreQs.append('tic', activeQueryStrings.tic);
        }

        if (widgetType && widgetType !== 'fullEmbed' && widgetEventId && widgetEventId > 0) {
            _buyMoreLink = eventSitePath + '/' + widgetType + '?' + _buyMoreQs.toString();
        } else if (isEventListingWidget) {
            _buyMoreLink = eventSitePath + '/landing?' + _buyMoreQs.toString();
        } else {
            _buyMoreLink = eventSitePath + '/sessions?' + _buyMoreQs.toString();
        }
    }

    if (accountId > 0) {
        var _GcPurchaseQs = new URLSearchParams();

        _findOtherEventsQs.append('aid', accountId.toString());
        _GcPurchaseQs.append('aid', accountId.toString());

        if (activeQueryStrings.embed) {
            _findOtherEventsQs.append('embed', activeQueryStrings.embed);
            _GcPurchaseQs.append('embed', activeQueryStrings.embed);
        }

        if (activeQueryStrings.widget) {
            _findOtherEventsQs.append('widget', activeQueryStrings.widget);
            _GcPurchaseQs.append('widget', activeQueryStrings.widget);

            if (widgetType && widgetEventId && widgetEventId > 0) {
                _GcPurchaseQs.append('type', widgetType);
                _GcPurchaseQs.append('eid', widgetEventId.toString());
            }
        }

        if (isEventListingWidget && accountId > 0) {
            _GcPurchaseQs.append('wp', 'true');
            _GcPurchaseQs.append('isEventListingWidget', 'True');
            _GcPurchaseQs.append('widget', 'true');
            _findOtherEventsQs.append('wp', 'true');
            _findOtherEventsQs.append('widget', 'true');
            _findOtherEventsQs.append('isEventListingWidget', 'True');
        }

        if (activeQueryStrings.qs) {
            _findOtherEventsQs.append('qs', activeQueryStrings.qs);
            _GcPurchaseQs.append('qs', activeQueryStrings.qs);
        }

        if (activeQueryStrings.source) {
            _findOtherEventsQs.append('source', activeQueryStrings.source);
            _GcPurchaseQs.append('source', activeQueryStrings.source);
        }

        if (activeQueryStrings.cid) {
            _findOtherEventsQs.append('cid', activeQueryStrings.cid);
            _GcPurchaseQs.append('cid', activeQueryStrings.cid);
        }


        _buyGcLink = eventSitePath + '/giftcertificate/' + accountId.toString() + '?' + _GcPurchaseQs.toString();
        _findOtherEventsLink = bookingSitePath + '/book/search?' + _findOtherEventsQs.toString();
    }

    return {
        buyMoreLink: _buyMoreLink,
        findOtherEventsLink: _findOtherEventsLink,
        buyGiftCertificateLink: _buyGcLink
    };
}


export function GetEventIds(shoppingCart: CartModel) {
    const eventIds: number[] = [];

    $.each(shoppingCart.tickets, (index: number, value: TicketModel) => {
        var eidExists = eventIds.findIndex(function (i, v) { v === value.eventId; }) >= 0;

        if (!eidExists) {
            eventIds.push(value.eventId);
        }
    });

    return eventIds;
}